/** Shared section vertical spacing defaults (MUI theme spacing units). */

export const SECTION_MB = {
  standard: { xs: 16, md: 20 },
  category: { xs: 12, md: 14 },
  homeHero: { xs: 10, lg: 16 },
  dualHero: { xs: 6, lg: 10 },
  bannerHero: { xs: 6, lg: 10 },
  bannerHeroSmall: { xs: 2, lg: 2 },
  giftCards: { xs: 14, md: 18 },
  giftCardsSmall: { xs: 9, md: 14 },
};

/**
 * Resolve optional page-level `mt` / `mb` overrides.
 * Pass `mb: 0` (or `false`) to remove default bottom spacing.
 */
export function resolveSectionSpacing(
  { mt, mb } = {},
  { mt: defaultMt, mb: defaultMb } = {},
) {
  return {
    mt: mt !== undefined ? mt : defaultMt,
    mb: mb === false ? 0 : mb !== undefined ? mb : defaultMb,
  };
}
